module.exports = __webpack_public_path__ + "static/media/G1-F1-Palácio-das-Amazonas-codF2.679dd49f.png";